import BaseMapper from '../../BaseMapper';

const MarketMapper = (data, context = {}) => {
    const { eventId = data.eventId } = context;

    data.closed = data.frozen || data.status > 0;

    data.eventId = eventId;
    data.id = eventId + data.marketHash;

    return data;
};

export default MarketMapper;
